export default "__VITE_ASSET__C7I5GaM9__"